interface WithPortfolioOrder {
  /** 회사 번호 */
  idx: number;
  /** 정렬 순서 값(`info_portfolio.custom_order`) — 클수록 앞 */
  customOrder: number;
}

/**
 * 포트폴리오 순서 — 모든 목록이 같다(메인 · 펀드 상세 · 아래 이동 줄 · 계정 관리, 사용자 2026-10-08).
 * 정렬 순서 값(custom_order) 내림차순, 같으면 회사 번호 오름차순. 한 회사의 여러 줄(펀드별)은 받은 순서(펀드 번호 순) 그대로.
 * 레거시 메인 PortfolioListLayout 의 규칙. 원본 배열은 바꾸지 않는다.
 */
export function sortByPortfolioOrder<T extends WithPortfolioOrder>(items: readonly T[]): T[] {
  return [...items].sort((a, b) => b.customOrder - a.customOrder || a.idx - b.idx);
}
